import React, { useEffect, useState } from 'react';
import {
    Container, Typography, Box, Grid, Card, CardMedia,
    CardContent, CircularProgress, Alert, Chip
} from '@mui/material';
import { EmojiEvents } from '@mui/icons-material';
import NavbarMain from '../components/NavbarMain';
import axios from 'axios';
import Footer from '../components/Footer';
import SEO from '../components/SEO'; // ✅ ДОДАДЕНО

const AchievementsPage = () => {
    const [achievements, setAchievements] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchAchievements();
    }, []);

    const fetchAchievements = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/achievements`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            setAchievements(res.data);
            setError('');
        } catch (err) {
            console.error('Error fetching achievements:', err);
            if (err.response?.status === 403) {
                setError('Морате да се најавите за да ги видите достигнувањата.');
            } else {
                setError('Грешка при вчитување на достигнувања. Обидете се повторно.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* ✅ SEO */}
            <SEO
                title="Достигнувања - BodyLab by Anamarija"
                description="Погледни ги резулта��ите и трансформациите на нашите клиенти. Реални приказни, реални резултати со BodyLab фитнес програмите."
                url="/achievements"
            />

            <NavbarMain />
            <Box sx={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #ffeef8 0%, #e0f7ff 100%)',
                pt: 12, pb: 10
            }}>
                <Container maxWidth="lg">

                    {/* ===== HEADER ===== */}
                    <Box textAlign="center" mb={8}>
                        <Box sx={{
                            width: 72, height: 72, borderRadius: '50%', mx: 'auto', mb: 3,
                            background: 'linear-gradient(135deg, #ff7eb9, #ffd166)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            boxShadow: '0 8px 32px rgba(255,126,185,0.35)'
                        }}>
                            <EmojiEvents sx={{ fontSize: 40, color: 'white' }} />
                        </Box>

                        {/* ✅ H1 */}
                        <Typography variant="h1" sx={{
                            fontWeight: 900,
                            background: 'linear-gradient(45deg, #ff7eb9, #AB47BC)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            mb: 1.5,
                            fontSize: { xs: '2.2rem', md: '3rem' }
                        }}>
                            Достигнувања 🏆
                        </Typography>

                        {/* ✅ H2 */}
                        <Typography variant="h2" sx={{
                            color: '#888', fontWeight: 400,
                            maxWidth: 600, mx: 'auto',
                            fontSize: { xs: '1rem', md: '1.25rem' }
                        }}>

                        </Typography>

                        <Box sx={{
                            width: 60, height: 4, borderRadius: 2,
                            background: 'linear-gradient(90deg, #ff7eb9, #ffd166)',
                            mx: 'auto', mt: 2
                        }} />
                    </Box>

                    {/* ===== ERROR ===== */}
                    {error && (
                        <Alert severity="error" sx={{ mb: 4, borderRadius: 2, maxWidth: 600, mx: 'auto' }}>
                            {error}
                        </Alert>
                    )}

                    {/* ===== LOADING ===== */}
                    {loading ? (
                        <Box display="flex" justifyContent="center" py={8}>
                            <CircularProgress size={60} sx={{ color: '#ff7eb9' }} />
                        </Box>
                    ) : achievements.length === 0 ? (
                        <Box sx={{
                            textAlign: 'center', py: 10,
                            border: '2px dashed rgba(255,126,185,0.3)',
                            borderRadius: '20px',
                            backgroundColor: 'rgba(255,126,185,0.03)'
                        }}>
                            <Typography variant="h5" sx={{ color: '#bbb', mb: 1 }}>
                                📭 Моментално нема достигнувања за приказ.
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#ccc' }}>
                                Наскоро ќе бидат додадени нови!
                            </Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={4}>
                            {achievements.map((ach, index) => (
                                <Grid item xs={12} sm={6} md={4} key={ach.id}>
                                    <Card sx={{
                                        height: '100%', display: 'flex', flexDirection: 'column',
                                        borderRadius: '20px', overflow: 'hidden',
                                        backgroundColor: '#ffffff',
                                        border: '1px solid rgba(255,126,185,0.15)',
                                        boxShadow: '0 4px 24px rgba(255,126,185,0.08)',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            transform: 'translateY(-8px)',
                                            boxShadow: '0 16px 48px rgba(255,126,185,0.2)',
                                            borderColor: 'rgba(255,126,185,0.35)'
                                        }
                                    }}>
                                        {ach.imageUrl ? (
                                            <CardMedia
                                                component="img"
                                                height="220"
                                                image={ach.imageUrl}
                                                alt={ach.title}
                                                sx={{ objectFit: 'cover' }}
                                            />
                                        ) : (
                                            <Box sx={{
                                                height: 6,
                                                background: index % 3 === 0
                                                    ? 'linear-gradient(90deg, #ff7eb9, #AB47BC)'
                                                    : index % 3 === 1
                                                        ? 'linear-gradient(90deg, #ffd166, #ff7eb9)'
                                                        : 'linear-gradient(90deg, #a5d8ff, #ff7eb9)'
                                            }} />
                                        )}

                                        <CardContent sx={{
                                            flexGrow: 1, display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center', p: 3
                                        }}>
                                            <Chip
                                                label="Достигнување" size="small"
                                                sx={{
                                                    bgcolor: 'rgba(255,126,185,0.1)',
                                                    color: '#ff7eb9', fontWeight: 'bold',
                                                    fontSize: '0.68rem',
                                                    border: '1px solid rgba(255,126,185,0.25)', mb: 2
                                                }}
                                            />
                                            {ach.value && (
                                                <Typography variant="h3" sx={{
                                                    fontWeight: 900,
                                                    background: 'linear-gradient(45deg, #ff7eb9, #AB47BC)',
                                                    WebkitBackgroundClip: 'text',
                                                    WebkitTextFillColor: 'transparent',
                                                    mb: 1, textAlign: 'center',
                                                    fontSize: { xs: '1.8rem', md: '2.2rem' }
                                                }}>
                                                    {ach.icon && `${ach.icon} `}{ach.value}
                                                </Typography>
                                            )}

                                            {/* ✅ H4 за наслов на секое достигнување */}
                                            <Typography variant="h4" sx={{
                                                fontWeight: 800, color: '#1a1a1a',
                                                textAlign: 'center', mb: 1.5, lineHeight: 1.3,
                                                fontSize: { xs: '1.1rem', md: '1.3rem' }
                                            }}>
                                                {ach.title}
                                            </Typography>

                                            <Box sx={{
                                                width: 40, height: 3, borderRadius: 2,
                                                background: 'linear-gradient(90deg, #ff7eb9, #ffd166)', mb: 1.5
                                            }} />
                                            <Typography variant="body1" sx={{
                                                color: '#666', textAlign: 'center',
                                                lineHeight: 1.7, fontSize: '0.95rem'
                                            }}>
                                                {ach.description}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </Container>
            </Box>
            <Footer />
        </>
    );
};

export default AchievementsPage;